<template>
  <div class="text-main-title">
    <button
      type="button"
      class="btn btn-theme button-position"
      v-on:click="resetFields()"
    >
      <i class="mdi mdi-arrow-left"></i> Back
    </button>
    <h2 class="titleStepForm">Personal Information</h2>
  </div>
  <div class="main-from-group my-4">
    <div class="row">
      <template v-if="isPdf">
      <div class="col-lg-12 mb-3">
        <div class="d-block">
          <label class="font-size-14">Branch</label>
          <input
            type="text"
            v-model="form.personal.branchName"
            class="form-control"
            :class="{
              'is-invalid':
                v$.form.personal.branchName.$error,
            }"
            placeholder="Branch"
            disabled
          />
          <div
            v-for="(personal, index) in v$.form.personal
              .branchName.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
      </div>
      <!-- Optional validation: personNum -->
      <div class="col-12 mb-3">
        <div class="groupFormStyle">
          <div class="row">
            <div class="col-12">
              <h3 class="formMainHeading">Applicant</h3>
            </div>
            <div class="col-lg-3 col-md-6 mb-3">
              <div class="d-block">
                <label class="font-size-14">Title</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="form.personal.title"
                  :class="{
                    'is-invalid':
                      v$.form.personal.title.$error,
                  }"
                  placeholder="Title"
                  disabled
                />
                <div
                  v-for="(personal, index) in v$.form.personal
                    .title.$errors"
                  :key="index"
                  class="invalid-feedback"
                >
                  <span v-if="personal.$message">{{
                    personal.$message
                  }}</span>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 mb-3">
              <div class="d-block">
                <label class="font-size-14">Surname</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Surname"
                  :class="{
                    'is-invalid':
                      v$.form.personal.surname.$error,
                  }"
                  v-model="form.personal.surname"
                  disabled
                />
                <div
                  v-for="(personal, index) in v$.form.personal
                    .surname.$errors"
                  :key="index"
                  class="invalid-feedback"
                >
                  <span v-if="personal.$message">{{
                    personal.$message
                  }}</span>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 mb-3">
              <div class="d-block">
                <label class="font-size-14">First Name</label>
                <input
                  type="text"
                  v-model="form.personal.firstName"
                  class="form-control"
                  :class="{
                    'is-invalid':
                      v$.form.personal.firstName.$error,
                  }"
                  placeholder="First Name"
                  disabled
                />
                <div
                  v-for="(personal, index) in v$.form.personal
                    .firstName.$errors"
                  :key="index"
                  class="invalid-feedback"
                >
                  <span v-if="personal.$message">{{
                    personal.$message
                  }}</span>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 mb-3">
              <div class="d-block">
                <label class="font-size-14"
                  >Middle Name</label
                >
                <input
                  type="text"
                  v-model="form.personal.middleName"
                  class="form-control"
                  :class="{
                    'is-invalid':
                      v$.form.personal.middleName.$error,
                  }"
                  placeholder="Middle Name"
                  disabled
                />
                <div
                  v-for="(personal, index) in v$.form.personal
                    .middleName.$errors"
                  :key="index"
                  class="invalid-feedback"
                >
                  <span v-if="personal.$message">{{
                    personal.$message
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </template>
      <template v-if="!isPdf">
      <div class="groupFormStyle mb-4">
        <div class="col-lg-12 mb-3">
          <div class="d-block">
            <label class="font-size-14">Branch</label>
            <input
              type="text"
              v-model="form.personal.branchName"
              class="form-control"
              :class="{
                'is-invalid':
                  v$.form.personal.branchName.$error,
              }"
              placeholder="Branch"
              disabled
            />
            <div
              v-for="(personal, index) in v$.form.personal
                .branchName.$errors"
              :key="index"
              class="invalid-feedback"
            >
              <span v-if="personal.$message">{{
                personal.$message
              }}</span>
            </div>
          </div>
        </div>
        <hr />
        <div class="col-12">
          <div class="row">
            <div class="col-12">
              <h3 class="formMainHeading">Applicant</h3>
            </div>
            <div class="col-lg-3 col-md-6 mb-3">
              <div class="d-block">
                <label class="font-size-14">Title</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="form.personal.title"
                  :class="{
                    'is-invalid':
                      v$.form.personal.title.$error,
                  }"
                  placeholder="Title"
                  disabled
                />
                <div
                  v-for="(personal, index) in v$.form.personal
                    .title.$errors"
                  :key="index"
                  class="invalid-feedback"
                >
                  <span v-if="personal.$message">{{
                    personal.$message
                  }}</span>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 mb-3">
              <div class="d-block">
                <label class="font-size-14">Surname</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Surname"
                  :class="{
                    'is-invalid':
                      v$.form.personal.surname.$error,
                  }"
                  v-model="form.personal.surname"
                  disabled
                />
                <div
                  v-for="(personal, index) in v$.form.personal
                    .surname.$errors"
                  :key="index"
                  class="invalid-feedback"
                >
                  <span v-if="personal.$message">{{
                    personal.$message
                  }}</span>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 mb-3">
              <div class="d-block">
                <label class="font-size-14">First Name</label>
                <input
                  type="text"
                  v-model="form.personal.firstName"
                  class="form-control"
                  :class="{
                    'is-invalid':
                      v$.form.personal.firstName.$error,
                  }"
                  placeholder="First Name"
                  disabled
                />
                <div
                  v-for="(personal, index) in v$.form.personal
                    .firstName.$errors"
                  :key="index"
                  class="invalid-feedback"
                >
                  <span v-if="personal.$message">{{
                    personal.$message
                  }}</span>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 mb-3">
              <div class="d-block">
                <label class="font-size-14"
                  >Middle Name</label
                >
                <input
                  type="text"
                  v-model="form.personal.middleName"
                  class="form-control"
                  :class="{
                    'is-invalid':
                      v$.form.personal.middleName.$error,
                  }"
                  placeholder="Middle Name"
                  disabled
                />
                <div
                  v-for="(personal, index) in v$.form.personal
                    .middleName.$errors"
                  :key="index"
                  class="invalid-feedback"
                >
                  <span v-if="personal.$message">{{
                    personal.$message
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </template>
      <div class="col-lg-12 mb-3">
        <div class="d-block">
          <label class="font-size-14">Home Address</label>
          <textarea
            type="textarea"
            v-model="form.personal.address"
            class="form-control"
            :class="{
              'is-invalid': v$.form.personal.address.$error,
            }"
            rows="1"
            placeholder="Home Address..."
            disabled
          ></textarea>
          <div
            v-for="(personal, index) in v$.form.personal
              .address.$errors"
            :key="index"
            class="invalid-feedback"
          >
            ``
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
      </div>
      <!-- Optional validation: geoCode -->
      <div class="col-lg-6 col-xl-4 mb-3">
        <div class="d-block">
          <label class="font-size-14">Address Line #1 </label>
          <textarea
            type="text"
            v-model="form.personal.address_line"
            class="form-control"
            rows="1"
            placeholder="Address Line #1...	"
            :class="{
              'is-invalid':
                v$.form.personal.address_line.$error,
            }"
            disabled
          ></textarea>

          <div
            v-for="(personal1, index) in v$.form.personal
              .address_line.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal1.$message">{{
              personal1.$message
            }}</span>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-xl-4 mb-3">
        <div class="d-block">
          <label class="font-size-14">Address Line #2 </label>
          <textarea
            type="text"
            v-model="form.personal.address_line_two"
            class="form-control"
            rows="1"
            placeholder="Address Line #2...	"
            :class="{
              'is-invalid':
                v$.form.personal.address_line_two.$error,
            }"
            disabled
          ></textarea>

          <div
            v-for="(personal, index) in v$.form.personal
              .address_line_two.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-xl-4 mb-3">
        <div class="d-block">
          <label class="font-size-14">City</label>
          <input
            type="text"
            v-model="form.personal.city_name"
            class="form-control"
            rows="1"
            placeholder="City...	"
            :class="{
              'is-invalid': v$.form.personal.city_name.$error,
            }"
            disabled
          />

          <div
            v-for="(personal, index) in v$.form.personal
              .city_name.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal1.$message
            }}</span>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-xl-4 mb-3">
        <div class="d-block">
          <label class="font-size-14">State / Prov</label>
          <input
            type="text"
            v-model="form.personal.state_name"
            class="form-control"
            rows="1"
            placeholder="State / Prov...	"
            :class="{
              'is-invalid':
                v$.form.personal.state_name.$error,
            }"
            disabled
          />

          <div
            v-for="(personal, index) in v$.form.personal
              .state_name.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-xl-4 mb-3">
        <div class="d-block">
          <label class="font-size-14">Zip Code</label>
          <input
            type="number"
            v-model="form.personal.zip_code"
            class="form-control"
            rows="1"
            placeholder="Zip...	"
            :class="{
              'is-invalid': v$.form.personal.zip_code.$error,
            }"
            disabled
          />

          <div
            v-for="(personal, index) in v$.form.personal
              .zip_code.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-xl-4 mb-3">
        <div class="d-block">
          <label class="font-size-14">Country</label>
          <input
            type="text"
            v-model="form.personal.country_name"
            class="form-control"
            rows="1"
            placeholder="Country...	"
            :class="{
              'is-invalid':
                v$.form.personal.country_name.$error,
            }"
            disabled
          />

          <div
            v-for="(personal, index) in v$.form.personal
              .country_name.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
      </div>
      <div class="col-lg-4 mb-3">
        <div class="d-block">
          <label class="font-size-14">Date of Birth</label>
          <AppDatePicker v-model="form.personal.dob" placeholder="Select date of birth" past-only :invalid="v$.form.personal.dob.$error" disabled />
          <div
            v-for="(personal, index) in v$.form.personal.dob
              .$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
      </div>
      <div class="col-lg-4 mb-3">
        <h4 class="font-size-14">Gender</h4>
        <div class="row">
          <div class="col-auto mb-2">
            <label
              for="maleGender"
              class="mb-0 w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
              :class="{
                'is-invalid': v$.form.personal.gender.$error,
              }"
            >
              <input
                type="radio"
                v-model="form.personal.gender"
                name="genderRadio"
                class="inputRadioCstm d-none"
                id="maleGender"
                value="male"
                disabled
              />
              <span class="radioCircleIcon">
                <i
                  class="mdi mdi-circle-outline text-theme font-size-20"
                ></i>
                <i
                  class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                ></i>
              </span>
              <h4
                class="font-size-14 text-dark-custom mb-0 ms-1"
              >
                Male
              </h4>
            </label>
            <div
              v-for="(personal, index) in v$.form.personal
                .gender.$errors"
              :key="index"
              class="invalid-feedback"
            >
              <span v-if="personal.$message">{{
                personal.$message
              }}</span>
            </div>
          </div>
          <div class="col-auto mb-2">
            <label
              for="femaleGender"
              class="mb-0 w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
              :class="{
                'is-invalid': v$.form.personal.gender.$error,
              }"
            >
              <input
                type="radio"
                v-model="form.personal.gender"
                name="genderRadio"
                class="inputRadioCstm d-none"
                id="femaleGender"
                value="female"
                disabled
              />
              <span class="radioCircleIcon">
                <i
                  class="mdi mdi-circle-outline text-theme font-size-20"
                ></i>
                <i
                  class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                ></i>
              </span>
              <h4
                class="font-size-14 text-dark-custom mb-0 ms-1"
              >
                Female
              </h4>
            </label>
            <div
              v-for="(personal, index) in v$.form.personal
                .gender.$errors"
              :key="index"
              class="invalid-feedback"
            >
              <span v-if="personal.$message">{{
                personal.$message
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 mb-3">
        <div class="d-block">
          <label class="font-size-14"
            >No. of Dependants</label
          >
          <input
            type="number"
            v-model="form.personal.numOfDependents"
            class="form-control"
            :class="{
              'is-invalid':
                v$.form.personal.numOfDependents.$error,
            }"
            placeholder="No. of Dependants"
            disabled
          />
          <div
            v-for="(personal, index) in v$.form.personal
              .numOfDependents.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
          <!-- Optional form input -->
        </div>
      </div>
      <div class="col-lg-6 mb-3">
        <div class="d-block">
          <label class="font-size-14">Place of Birth</label>
          <input
            type="text"
            v-model="form.personal.placeOfdob"
            class="form-control"
            :class="{
              'is-invalid':
                v$.form.personal.placeOfdob.$error,
            }"
            placeholder="Place of Birth"
            disabled
          />
          <div
            v-for="(personal, index) in v$.form.personal
              .placeOfdob.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
      </div>
      <div class="col-lg-6 mb-3">
        <div class="d-block">
          <label class="font-size-14">Nationality</label>
          <input
            type="text"
            v-model="form.personal.nationality"
            class="form-control"
            :class="{
              'is-invalid':
                v$.form.personal.nationality.$error,
            }"
            placeholder="Nationality"
            disabled
          />
          <div
            v-for="(personal, index) in v$.form.personal
              .nationality.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
      </div>
      <div class="col-12 mb-3">
        <h4 class="font-size-14">Marital Status</h4>
        <div class="row">
          <div class="col-auto mb-2">
            <label
              for="singleMat"
              class="mb-0 w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
              :class="{
                'is-invalid':
                  v$.form.personal.maritalStatus.$error,
              }"
            >
              <input
                type="radio"
                v-model="form.personal.maritalStatus"
                value="single"
                name="materialRadio"
                class="inputRadioCstm d-none"
                id="singleMat"
                disabled
              />
              <span class="radioCircleIcon">
                <i
                  class="mdi mdi-circle-outline text-theme font-size-20"
                ></i>
                <i
                  class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                ></i>
              </span>
              <h4
                class="font-size-14 text-dark-custom mb-0 ms-1"
              >
                Single
              </h4>
            </label>
            <div
              v-for="(personal, index) in v$.form.personal
                .maritalStatus.$errors"
              :key="index"
              class="invalid-feedback"
            >
              <span v-if="personal.$message">{{
                personal.$message
              }}</span>
            </div>
          </div>
          <div class="col-auto mb-2">
            <label
              for="marriedMat"
              class="mb-0 w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
              :class="{
                'is-invalid':
                  v$.form.personal.maritalStatus.$error,
              }"
            >
              <input
                type="radio"
                v-model="form.personal.maritalStatus"
                value="married"
                name="materialRadio"
                class="inputRadioCstm d-none"
                id="marriedMat"
                disabled
              />
              <span class="radioCircleIcon">
                <i
                  class="mdi mdi-circle-outline text-theme font-size-20"
                ></i>
                <i
                  class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                ></i>
              </span>
              <h4
                class="font-size-14 text-dark-custom mb-0 ms-1"
              >
                Married
              </h4>
            </label>
            <div
              v-for="(personal, index) in v$.form.personal
                .maritalStatus.$errors"
              :key="index"
              class="invalid-feedback"
            >
              <span v-if="personal.$message">{{
                personal.$message
              }}</span>
            </div>
          </div>
          <div class="col-auto mb-2">
            <label
              for="divorcedMat"
              class="mb-0 w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
              :class="{
                'is-invalid':
                  v$.form.personal.maritalStatus.$error,
              }"
            >
              <input
                type="radio"
                v-model="form.personal.maritalStatus"
                value="divorced"
                name="materialRadio"
                class="inputRadioCstm d-none"
                id="divorcedMat"
                disabled
              />
              <span class="radioCircleIcon">
                <i
                  class="mdi mdi-circle-outline text-theme font-size-20"
                ></i>
                <i
                  class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                ></i>
              </span>
              <h4
                class="font-size-14 text-dark-custom mb-0 ms-1"
              >
                Divorced
              </h4>
            </label>
            <div
              v-for="(personal, index) in v$.form.personal
                .maritalStatus.$errors"
              :key="index"
              class="invalid-feedback"
            >
              <span v-if="personal.$message">{{
                personal.$message
              }}</span>
            </div>
          </div>
          <div class="col-auto mb-2">
            <label
              for="widowedMat"
              class="mb-0 w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
              :class="{
                'is-invalid':
                  v$.form.personal.maritalStatus.$error,
              }"
            >
              <input
                type="radio"
                v-model="form.personal.maritalStatus"
                value="widowed"
                name="materialRadio"
                class="inputRadioCstm d-none"
                id="widowedMat"
                disabled
              />
              <span class="radioCircleIcon">
                <i
                  class="mdi mdi-circle-outline text-theme font-size-20"
                ></i>
                <i
                  class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                ></i>
              </span>
              <h4
                class="font-size-14 text-dark-custom mb-0 ms-1"
              >
                Widowed
              </h4>
            </label>
            <div
              v-for="(personal, index) in v$.form.personal
                .maritalStatus.$errors"
              :key="index"
              class="invalid-feedback"
            >
              <span v-if="personal.$message">{{
                personal.$message
              }}</span>
            </div>
          </div>
          <div class="col-auto mb-2">
            <label
              for="separatedMat"
              class="mb-0 w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
              :class="{
                'is-invalid':
                  v$.form.personal.maritalStatus.$error,
              }"
            >
              <input
                type="radio"
                v-model="form.personal.maritalStatus"
                value="separated"
                name="materialRadio"
                class="inputRadioCstm d-none"
                id="separatedMat"
                disabled
              />
              <span class="radioCircleIcon">
                <i
                  class="mdi mdi-circle-outline text-theme font-size-20"
                ></i>
                <i
                  class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                ></i>
              </span>
              <h4
                class="font-size-14 text-dark-custom mb-0 ms-1"
              >
                Separated
              </h4>
            </label>
            <div
              v-for="(personal, index) in v$.form.personal
                .maritalStatus.$errors"
              :key="index"
              class="invalid-feedback"
            >
              <span v-if="personal.$message">{{
                personal.$message
              }}</span>
            </div>
          </div>

          <div class="col-auto mb-2">
            <label
              for="commonLawMat"
              class="mb-0 w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
              :class="{
                'is-invalid':
                  v$.form.personal.maritalStatus.$error,
              }"
            >
              <input
                type="radio"
                v-model="form.personal.maritalStatus"
                value="common_low"
                name="materialRadio"
                class="inputRadioCstm d-none"
                id="commonLawMat"
                disabled
              />
              <span class="radioCircleIcon">
                <i
                  class="mdi mdi-circle-outline text-theme font-size-20"
                ></i>
                <i
                  class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                ></i>
              </span>
              <h4
                class="font-size-14 text-dark-custom mb-0 ms-1"
              >
                Common Law
              </h4>
            </label>
            <div
              v-for="(personal, index) in v$.form.personal
                .maritalStatus.$errors"
              :key="index"
              class="invalid-feedback"
            >
              <span v-if="personal.$message">{{
                personal.$message
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3 mb-3">
        <div class="d-block">
          <label class="font-size-14"
            >National Identification No.</label
          >
          <input
            type="number"
            v-model="form.personal.nationalIdNum"
            class="form-control"
            :class="{
              'is-invalid':
                v$.form.personal.nationalIdNum.$error,
            }"
            placeholder="National Identification No."
            disabled
          />
          <div
            v-for="(personal, index) in v$.form.personal
              .nationalIdNum.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
      </div>
      <div class="col-lg-3 mb-3">
        <div class="d-block">
          <label class="font-size-14">Issue Date</label>
          <AppDatePicker v-model="form.personal.nidIssueDate" placeholder="Select issue date" :invalid="v$.form.personal.nidIssueDate.$error" disabled />
          <div
            v-for="(personal, index) in v$.form.personal
              .nidIssueDate.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
      </div>
      <div class="col-lg-3 mb-3">
        <div class="d-block">
          <label class="font-size-14">Expiry Date</label>
          <AppDatePicker v-model="form.personal.nidExpiry" placeholder="Select expiry date" :invalid="v$.form.personal.nidExpiry.$error" disabled />
          <div
            v-for="(personal, index) in v$.form.personal
              .nidExpiry.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
      </div>
      <div class="col-lg-3 mb-3">
        <div class="d-block">
          <label class="font-size-14"
            >Country of Issuance</label
          >
          <div class="single-select2-cstm">
            <Select2
              v-model="form.personal.nationalIssuance"
              :class="{
                'is-invalid':
                  v$.form.personal.nationalIssuance.$error,
              }"
              placeholder="Select"
              :options="nationalIssuanceOpt"
              disabled
            />
            <div
              v-for="(personal, index) in v$.form.personal
                .nationalIssuance.$errors"
              :key="index"
              class="invalid-feedback"
            >
              <span v-if="personal.$message">{{
                personal.$message
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-3 mb-3">
        <div class="d-block">
          <label class="font-size-14"
            >Driver’s Permit No.</label
          >
          <input
            type="number"
            v-model="form.personal.drivingIdNum"
            class="form-control"
            :class="{
              'is-invalid':
                v$.form.personal.drivingIdNum.$error,
            }"
            placeholder="Driver’s Permit No."
            disabled
          />
          <div
            v-for="(personal, index) in v$.form.personal
              .drivingIdNum.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
      </div>
      <div class="col-lg-3 mb-3">
        <div class="d-block">
          <label class="font-size-14">Issue Date</label>
          <AppDatePicker v-model="form.personal.didIssueDate" placeholder="Select issue date" :invalid="v$.form.personal.didIssueDate.$error" disabled />
          <div
            v-for="(personal, index) in v$.form.personal
              .didIssueDate.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
      </div>
      <div class="col-lg-3 mb-3">
        <div class="d-block">
          <label class="font-size-14">Expiry Date</label>
          <AppDatePicker v-model="form.personal.didExpiry" placeholder="Select expiry date" :invalid="v$.form.personal.didExpiry.$error" disabled />
          <div
            v-for="(personal, index) in v$.form.personal
              .didExpiry.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
      </div>
      <div class="col-lg-3 mb-3">
        <div class="d-block">
          <label class="font-size-14"
            >Country of Issuance</label
          >
          <div class="single-select2-cstm">
            <Select2
              v-model="form.personal.driverIssuance"
              placeholder="Select"
              :class="{
                'is-invalid':
                  v$.form.personal.driverIssuance.$error,
              }"
              :options="nationalIssuanceOpt"
              disabled
            />
            <div
              v-for="(personal, index) in v$.form.personal
                .driverIssuance.$errors"
              :key="index"
              class="invalid-feedback"
            >
              <span v-if="personal.$message">{{
                personal.$message
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-3 mb-3">
        <div class="d-block">
          <label class="font-size-14">Passport No.</label>
          <input
            type="text"
            v-model="form.personal.passportNum"
            class="form-control"
            :class="{
              'is-invalid':
                v$.form.personal.passportNum.$error,
            }"
            placeholder="Passport No."
            disabled
          />
          <div
            v-for="(personal, index) in v$.form.personal
              .passportNum.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
      </div>
      <div class="col-lg-3 mb-3">
        <div class="d-block">
          <label class="font-size-14">Issue Date</label>
          <AppDatePicker v-model="form.personal.passIssueDate" placeholder="Select issue date" :invalid="v$.form.personal.passIssueDate.$error" disabled />
          <div
            v-for="(personal, index) in v$.form.personal
              .passIssueDate.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
      </div>
      <div class="col-lg-3 mb-3">
        <div class="d-block">
          <label class="font-size-14">Expiry Date</label>
          <AppDatePicker v-model="form.personal.passExpiry" placeholder="Select expiry date" :invalid="v$.form.personal.passExpiry.$error" disabled />
          <div
            v-for="(personal, index) in v$.form.personal
              .passExpiry.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
      </div>
      <div class="col-lg-3 mb-3">
        <div class="d-block">
          <label class="font-size-14"
            >Country of Issuance</label
          >
          <div class="single-select2-cstm">
            <Select2
              v-model="form.personal.passportIssuance"
              placeholder="Select"
              :class="{
                'is-invalid':
                  v$.form.personal.passportIssuance.$error,
              }"
              :options="nationalIssuanceOpt"
              disabled
            />
            <div
              v-for="(personal, index) in v$.form.personal
                .passportIssuance.$errors"
              :key="index"
              class="invalid-feedback"
            >
              <span v-if="personal.$message">{{
                personal.$message
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <template v-if="radioSelected === 'minor'">
        <div class="col-lg-6 mb-3">
          <div class="d-block">
            <label class="font-size-14"
              >Birth Certificate PIN No.
              <sup>(for minors)</sup>
            </label>
            <input
              type="text"
              v-model="form.personal.birthIdNum"
              class="form-control"
              :class="{
                'is-invalid':
                  v$.form.personal.birthIdNum.$error,
              }"
              placeholder="Birth Certificate PIN No."
              disabled
            />
            <div
              v-for="(personal, index) in v$.form.personal
                .birthIdNum.$errors"
              :key="index"
              class="invalid-feedback"
            >
              <span v-if="personal.$message">{{
                personal.$message
              }}</span>
            </div>
          </div>
        </div>
        <div class="col-lg-6 mb-3">
          <div class="d-block">
            <label class="font-size-14"
              >Country of Issuance</label
            >
            <div class="single-select2-cstm">
              <Select2
                v-model="form.personal.birthIssuance"
                placeholder="Select"
                :class="{
                  'is-invalid':
                    v$.form.personal.birthIssuance.$error,
                }"
                :options="nationalIssuanceOpt"
                disabled
              />
              <div
                v-for="(personal, index) in v$.form.personal
                  .birthIssuance.$errors"
                :key="index"
                class="invalid-feedback"
              >
                <span v-if="personal.$message">{{
                  personal.$message
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>
<template v-if="isPdf">

</template>
      <div class="col-lg-4 mb-3">
        <div class="d-block">
          <template v-if="isPdf">
          <label class="font-size-14">Home Phone No.</label>
          <input
            type="text"
            v-model="form.personal.homePhoneNum"
            class="form-control"
            :class="{
              'is-invalid':
                v$.form.personal.homePhoneNum.$error,
            }"
            placeholder="Home Phone No."
            disabled
          />
          <div
            v-for="(personal, index) in v$.form.personal
              .homePhoneNum.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
          </template>
          <template v-if="!isPdf">
          <label class="font-size-14"
            >Urgent Home Phone No.</label
          >
          <div class="row">
            <div class="col-4 pe-0">
              <div
                class="single-select2-cstm"
                style="min-width: 96px;margin-right: 10px;"
              >
                <Select2
                  v-model="form.personal.homePhoneNumcode"
                  :options="countrynameIssuanceOpt"
                  disabled
                >
                </Select2>
              </div>
            </div>
            <div class="col-8 ps-0">
              <input
                type="text"
                v-model="form.personal.homePhoneNum"
                class="form-control"
                placeholder="Home Phone No."
                disabled
              />
              <!-- Optional validation: homePhoneNum -->
            </div>
          </div>
          </template>
        </div>
      </div>
      <div class="col-lg-4 mb-3">
        <div class="d-block">
          <label class="font-size-14">Mobile No.</label>
          <template v-if="isPdf">
          <input
            type="text "
            v-model="form.personal.mobileNum"
            class="form-control"
            :class="{
              'is-invalid': v$.form.personal.mobileNum.$error,
            }"
            placeholder="Mobile No."
            disabled
          />
          <div
            v-for="(personal, index) in v$.form.personal
              .mobileNum.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
          </template>
          <template v-if="!isPdf">
          <div class="row">
            <div class="col-4 pe-0">
              <div
                class="single-select2-cstm"
                style="min-width: 96px;margin-right: 10px;"
              >
                <Select2
                  v-model="form.personal.mobileNumcode"
                  :options="countrynameIssuanceOpt"
                  disabled
                >
                </Select2>
              </div>
            </div>
            <div class="col-8 ps-0">
              <input
                type="text "
                v-model="form.personal.mobileNum"
                class="form-control"
                placeholder="Mobile No."
                disabled
              />
              <div
                v-for="(personal, index) in v$.form.personal
                  .mobileNum.$errors"
                :key="index"
                class="invalid-feedback"
              >
                <span v-if="personal.$message">{{
                  personal.$message
                }}</span>
              </div>
            </div>
          </div>
          </template>
        </div>
      </div>
      <div class="col-lg-4 mb-3">
        <div class="d-block">
          <label class="font-size-14">Email Address</label>
          <input
            type="email"
            v-model="form.personal.email"
            class="form-control"
            :class="{
              'is-invalid': v$.form.personal.email.$error,
            }"
            placeholder="Email Address"
            disabled
          />
          <div
            v-for="(personal, index) in v$.form.personal.email
              .$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="uploadFileSection groupFormStyle">
      <h2 class="formMainHeading">Upload Documents</h2>
      <div class="row">
        <div class="col-lg-4 mb-3">
          <div class="form-group">
            <label for="my-file"
              >National Identification</label
            >
            <div>
              <a
                v-if="imageUrl"
                :href="imageUrl"
                target="_blank"
              >
                <i
                  class="mdi mdi-file-document-multiple font-size-24 text-theme"
                ></i>
                <template v-if="!isPdf">
                <div>Click to Download</div>
                </template>
              </a>
              <div v-else>
                <i
                  class="mdi mdi-file-document-multiple font-size-24 text-theme"
                ></i>
                <div>No Document found</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 mb-3">
          <div class="form-group">
            <label for="my-file1">Driver’s Permit</label>
            <div>
              <a
                v-if="imageUrl_two"
                :href="imageUrl_two"
                target="_blank"
              >
                <i
                  class="mdi mdi-file-document-multiple font-size-24 text-theme"
                ></i>
                <template v-if="!isPdf">
                <div>Click to Download</div>
                </template>
              </a>
              <div v-else>
                <i
                  class="mdi mdi-file-document-multiple font-size-24 text-theme"
                ></i>
                <div>No Document found</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 mb-3">
          <div class="form-group">
            <label for="my-file2">Passport</label>
            <div>
              <a
                v-if="imageUrl_three"
                :href="imageUrl_three"
                target="_blank"
              >
                <i
                  class="mdi mdi-file-document-multiple font-size-24 text-theme"
                ></i>
                <template v-if="!isPdf">
                <div>Click to Download</div>
                </template>
              </a>
              <div v-else>
                <i
                  class="mdi mdi-file-document-multiple font-size-24 text-theme"
                ></i>
                <div>No Document found</div>
              </div>
            </div>
          </div>
        </div>
        <template v-if="!isPdf">
        <hr />
        </template>
        <div class="col-lg-4 mb-3">
          <div class="form-group">
            <label for="my-file3">Utility Bill</label>
            <div>
              <a
                v-if="imageUrl_four"
                :href="imageUrl_four"
                target="_blank"
              >
                <i
                  class="mdi mdi-file-document-multiple font-size-24 text-theme"
                ></i>
                <template v-if="!isPdf">
                <div>Click to Download</div>
                </template>
              </a>
              <div v-else>
                <i
                  class="mdi mdi-file-document-multiple font-size-24 text-theme"
                ></i>
                <div>No Document found</div>
              </div>
            </div>
          </div>
        </div>
        <template v-if="radioSelected1 === 'minor'">
          <div class="col-lg-4">
            <div class="form-group">
              <label for="my-file2"
                >Birth Certificate
                <sup>(For Minors)</sup></label
              >
              <div>
                <a
                  v-if="imageUrl_five"
                  :href="imageUrl_five"
                  target="_blank"
                >
                  <i
                    class="mdi mdi-file-document-multiple font-size-24 text-theme"
                  ></i>
                  <template v-if="!isPdf">
                  <div>Click to Download</div>
                  </template>
                </a>
                <div v-else>
                  <i
                    class="mdi mdi-file-document-multiple font-size-24 text-theme"
                  ></i>
                  <div>No Document found</div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-if="!isPdf">
        <!-- Optional field: Other's (Pay Slip Or Job Letter) -->
        <div class="col-lg-4 mb-3">
          <div class="form-group">
            <label for="my-file3"
              >Other's (Pay Slip Or Job Letter)</label
            >

            <div
              v-if="imageUrl_nine && imageUrl_nine.length > 0"
            >
              <!-- Show first 2 files -->
              <div
                v-for="(url, index) in imageUrl_nine.slice(
                  0,
                  1,
                )"
                :key="index"
                class="mb-2"
              >
                <a
                  :href="url"
                  target="_blank"
                  class="d-flex align-items-center"
                >
                  <i
                    class="mdi mdi-file-document-multiple font-size-24 text-theme"
                  ></i>
                  <div class="ml-2">
                    Click to Download File {{ index + 1 }}
                  </div>
                </a>
              </div>
            </div>

            <div v-else>
              <i
                class="mdi mdi-file-document-multiple font-size-24 text-theme"
              ></i>
              <div>No Document found</div>
            </div>
            <a
              v-if="imageUrl_nine && imageUrl_nine.length > 2"
              v-b-toggle="'collapse'"
              class="text-dark d-inline-flex align-items-center ml-2"
            >
              More Files
              <i
                class="text-primary bx bxs-down-arrow ml-1"
              ></i
            ></a>
            <b-collapse id="collapse" class="mt-1">
              <b-card class="form-group">
                <div
                  v-if="
                    imageUrl_nine && imageUrl_nine.length > 1
                  "
                >
                  <div
                    v-for="(
                      url, index
                    ) in imageUrl_nine.slice(1)"
                    :key="index"
                    class="mb-2"
                  >
                    <a
                      :href="url"
                      target="_blank"
                      class="d-flex align-items-center"
                    >
                      <i
                        class="mdi mdi-file-document-multiple font-size-24 text-theme"
                      ></i>
                      <div class="ml-2">
                        Click to Download File {{ index + 2 }}
                      </div>
                    </a>
                  </div>
                </div>
              </b-card>
            </b-collapse>
          </div>
        </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from "vue3-select2-component";
import { bridge } from "../formBridge";
import AppDatePicker from "@/components/shared/AppDatePicker.vue";

export default {
  name: "ReviewPersonalInfo",
  props: {
    variant: { type: String, default: "review" },
  },
  computed: {
    isPdf() {
      return this.variant === "pdf";
    },
  },
  mixins: [
    bridge({
    state: ["imageUrl", "imageUrl_two", "imageUrl_three", "imageUrl_four", "imageUrl_five", "imageUrl_nine", "radioSelected1", "radioSelected", "countrynameIssuanceOpt", "nationalIssuanceOpt", "form"],
    validate: true,
    }),
  ],
  components: { Select2, AppDatePicker },
};
</script>